import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import moment from 'moment';
import { routes } from '../../../redux/api/routes';
import { processOrder, saveOrderDetails } from '../../../redux/actions';
import PartsNetOrderCancellationDialog from '../../dialogs/partsNetOrderCancellationDialog';
import LineStatusDescriptionsOverlayDialog from '../../dialogs/lineStatusDescriptionsOverlayDialog';

import {
    validateWarehouseCode,
} from '../../../redux/actions';

const CANCELLABLE_LINE_STATUSES = [
    'Awaiting Shipping',
    'Backordered',
    'Internal Req Requested',
    'Internal Req Open',
    'Internal Req Partial'
];

// ── ONLY addition: mobile-only styles, everything ≥600px is untouched ────────
const mobileStyles = `
@media (max-width: 599px) {

    /* Stack action buttons vertically, full width */
    .approveDetailsHeader {
        flex-direction: column;
        align-items: stretch;
        gap: 0.75rem;
    }
    .approveDetailsHeader .textLeft {
        margin-right: 0 !important;
    }
    .approveDetailsHeaderItems {
        display: flex;
        flex-direction: column;
        gap: 0.625rem;
    }
    .approveDetailsHeaderItems button,
    .approveDetailsHeaderItems a.blueButton {
        width: 100%;
        text-align: center;
        margin-right: 0 !important;
        box-sizing: border-box;
    }

    /* Mobile order detail styles */
    .ncrp-mobile-wrap {
        padding: 0 1rem 1rem;
        font-size: 0.875rem;
    }
    .ncrp-mobile-wrap p {
        margin: 0 0 0.75rem;
        line-height: 1.6;
    }
    .ncrp-mobile-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.8125rem;
    }
    .ncrp-mobile-table th {
        background: #003087;
        color: #fff;
        padding: 0.5rem;
        text-align: left;
        font-weight: 600;
    }
    .ncrp-mobile-table th:first-child,
    .ncrp-mobile-table td:first-child {
        text-align: center;
        width: 2.25rem;
    }
    .ncrp-mobile-table td {
        padding: 0.5rem;
        border-bottom: 1px solid #e0e3ea;
        vertical-align: top;
        word-break: break-word;
    }
    .ncrp-mobile-table .col-qty {
        text-align: center;
        width: 4rem;
        white-space: nowrap;
    }
    .ncrp-mobile-table .totalRow td {
        font-weight: bold;
        background: #f0f2f5;
    }
    .ncrp-mobile-actions {
        display: flex;
        flex-direction: column;
        gap: 0.625rem;
        margin-top: 1rem;
    }
    .ncrp-mobile-actions button,
    .ncrp-mobile-actions a.blueButton {
        width: 100%;
        text-align: center;
        box-sizing: border-box;
        display: block;
        padding: 0.65rem 1rem;
    }
}
`;
// ─────────────────────────────────────────────────────────────────────────────

class ApproveNcrpOrderDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            backupOrderDetails: null,
            pickingUpByAddress: null,

            showGenericOverlayDialog: false,
            genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
            typeOfOrder: 'return',
            serState:'',
            selectedRows: [],
            selectedLineIds:[],
            isOrderCancelled: false, 
            areSelectedLinesCancelled: false,
            cancelledLineIndexes: []
        }
        this.updateStateWithOrderDetails = this.updateStateWithOrderDetails.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleRowSelect = this.handleRowSelect.bind(this);
        this.validateOrder = this.validateOrder.bind(this);
        this.validateLines = this.validateLines.bind(this);
        this.messageData = null,
        this.dialog = null
    }

    handleDialog(dialog, flag, event) {
        event && event.preventDefault();
        this.setState({
            ['show'+dialog]: false
        }, () => {
            this.setState({
                ['show'+dialog]: flag
            })
        })
    }

    openDialog = dialog => {
        this.setState({ dialog });
    };

    closeDialog = () => {
        this.setState({ dialog: null });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        var self = this,
            accountNumber = self.props.getSelectedAccountNumber();
        if(self.props.state.order.orderDetails && accountNumber) {
            self.updateStateWithOrderDetails(self.props.state.order.orderDetails);
        } else {
            browserHistory.push('/viewRequests');
        }
    }

    isOrderCancellable() {
        const { orderDetails } = this.state;
        if (!orderDetails || !orderDetails.items || !orderDetails.items.length) {
            return false;
        }
        const cancellableOrEnteredLineExists = orderDetails.items.some(item =>
            item.lineStatus &&
            (
                item.lineStatus.toUpperCase() === 'ENTERED' ||
                CANCELLABLE_LINE_STATUSES.includes(item.lineStatus)
            )
        );

        if (!cancellableOrEnteredLineExists) {
            return false;
        }
        const hasBlockingLine = orderDetails.items.some(item => {
            const status = item.lineStatus && item.lineStatus.toUpperCase();

            return (
                status &&
                !['ENTERED', 'CANCELLED'].includes(status) &&
                !CANCELLABLE_LINE_STATUSES.includes(status)
            );
        });

        return !hasBlockingLine;
    }


    updateStateWithOrderDetails(response) {
        var self = this;
        if(!response.status) {
            self.setState({
                errorMessage: response.responseMessage
            })
        } else {
            self.setState({
                backupOrderDetails: JSON.parse(JSON.stringify(response.responseObject))
            }, () => {
                let typeOfOrder = 'return';
                if(response.responseObject.items.length === response.responseObject.items.filter(item => item.lineType === 'Bill Only Line' || item.lineType === 'Other Credit').length) {
                    typeOfOrder = 'credit';
                }
                if(response.responseObject.shippingAddress.zip) {
                    response.responseObject.shippingAddress = new Array(response.responseObject.shippingAddress);
                }
                if(typeOfOrder === 'return' && response.responseObject.warehouseCode) {
                    self.props.validateWarehouseCode(`requestType=getWarehouseDetails&warehouseCode=${response.responseObject.warehouseCode}`, resp => {
                        if (resp.status && resp.responseObject && resp.responseObject.facilitycoreresponse && resp.responseObject.facilitycoreresponse.length) {
                            const data = resp.responseObject.facilitycoreresponse[0];
                            self.setState({
                                pickingUpByAddress: {
                                    dockname: data.facilityname ? data.facilityname.value : '',
                                    dockaddr: data.facilityaddressline1 ? data.facilityaddressline1.value : '',
                                    dockaddr2: data.facilityaddressline2 ? data.facilityaddressline2.value : '',
                                    dockaddr3: data.facilityaddressline3 ? data.facilityaddressline3.value : '',
                                    dockcity: data.facilitycity ? data.facilitycity.value : '',
                                    dockst: data.facilitystate ? data.facilitystate.value : '',
                                    dockzip: data.facilityzipcode ? data.facilityzipcode.value : '',
                                    dockphone: data.facilitylocationphone ? data.facilitylocationphone.value : '',
                                }
                            });
                        } else {
                            self.setState({
                                errorMessage: 'Invalid warehouse code.'
                            });
                        }
                    });
                }

                response.responseObject.items = _.filter(response.responseObject.items, (item) => {
                    return item.lineStatus !== 'CANCELLED';
                });

                response.responseObject.items.map((item, index) => {
                    let extendedPrice = null;
                    if(item.price && item.quantity) {
                        extendedPrice = parseInt(item.price, 10) * parseInt(item.quantity, 10);
                    }
                    item.shipSet = item.shipSet?item.shipSet:0
                    item.extendedPrice = extendedPrice;
                    return null;
                })

                response.responseObject.shippingAddress.map((item, index) => {
                    item.items = _.filter(response.responseObject.items, ['shipSet', item.shipSet]);
                    item.subTotal = _.sumBy(item.items, 'extendedPrice');
                    item.orderTax = _.sumBy(item.items, (itm) => {return parseFloat(itm.tax)}, 'tax');
                    item.orderTotal = item.orderTax + item.subTotal;
                    item.subPointValue = _.sumBy(item.items, (itm) => {return parseFloat(itm.pointValue)}, 'pointValue');
                    return null;
                });
                self.setState(
                { orderDetails: response.responseObject, typeOfOrder },
                () => {
                    const { orderDetails, cancelledLineIndexes } = self.state;
                    const selectableIndexes = orderDetails.items
                        .map((item, index) =>
                            self.isLineCancellable(item.lineStatus) &&
                            !cancelledLineIndexes.includes(index)
                                ? index
                                : null
                        )
                        .filter(i => i !== null);

                    if (selectableIndexes.length > 0) {
                        self.setState({ selectedRows: selectableIndexes });
                    }
                }
            );
            });
        }
    }

    handleSelectAll(e) {
        const { orderDetails, cancelledLineIndexes } = this.state;
        if (!orderDetails) return;

        const selectableIndexes = orderDetails.items
            .map((item, index) => {
                if (
                    this.isLineCancellable(item.lineStatus) &&
                    !cancelledLineIndexes.includes(index)
                ) {
                    return index;
                }
                return null;
            })
            .filter(function (i) { return i !== null; });

        if (e.target.checked) {
            this.setState({ selectedRows: selectableIndexes });
        } else {
            this.setState({ selectedRows: [] });
        }
    }


    handleRowSelect(index) {
        const { orderDetails, selectedRows } = this.state;
        const lineItem = orderDetails.items[index];

        if (!this.isLineCancellable(lineItem.lineStatus)) return;
        this.setState({
            selectedRows: selectedRows.includes(index)
                ? selectedRows.filter(i => i !== index)
                : [...selectedRows, index]
        });
    }

    handleReturnToPreviousPage(e) {
        e.preventDefault();
        const self = this;
        browserHistory.push('/approve-ncrp');
    }

    handleApproveReturn(event) {
        event.preventDefault();
        const payload = this.buildApproveOrderPayload();
        this.props.processOrder( payload, 'requestType=createOrder&appName=NCRP', true, (response) => {
                if (response && response.status && response.responseObject) {
                    this.setState({
                        genericDialogHeading: 'Order Approved',
                        genericDialogText: 'The NCRP order has been successfully approved.',
                        showGenericOverlayDialog: true
                    });
                    setTimeout(() => {
                        browserHistory.push('/approve-ncrp');
                    }, 1500);
                } else {
                    this.setState({
                        genericDialogHeading: 'Approval Failed',
                        genericDialogText:
                            response && response.responseMessage ||
                            'Unable to approve the order. Please try again.',
                        showGenericOverlayDialog: true
                    });
                }
            }
        );
    }


    handleOrderCancellation = ({ cancellationReason, cancellationComments }) => {
        this.closeDialog();
        const { orderDetails } = this.state;
        const user = this.props.state.user;
        const context = 'NCRP';
        if (!orderDetails) {
            return;
        }
        const payload = {
            P_OPERATION: 'UPDATE',
            P_HEADER_REC: {
                CANCELLED_FLAG: 'Y',
                HEADER_ID: orderDetails.headerId || orderDetails.id || orderDetails.orderNumber,
                ORDER_NUMBER: orderDetails.orderNumber,
                ORIG_SYS_DOCUMENT_REF:orderDetails.referenceNumber,
                OPERATION: 'UPDATE',
                CHANGE_REASON: cancellationReason,
                CHANGE_COMMENTS: cancellationComments.trim()
                    ? `${context} - ${user.userDetails.firstName} ${user.userDetails.lastName} - ${cancellationComments.trim()}`
                    : ''
            }
        };
        this.processCancellation(payload, 'HEADER');
    };

    processCancellation = (payload, type) => {
        const { processOrder } = this.props;
        const context = 'NCRP';

        this.setState({ messageData: null });

        processOrder(
            payload,
            'requestType=cancelOrder&appName=' + context,
            true,
            (cancellationResponse) => {

                if (
                    cancellationResponse &&
                    cancellationResponse.status &&
                    cancellationResponse.responseObject
                ) {
                    var responseObj = cancellationResponse.responseObject;

                    if (responseObj.X_RETURN_STATUS === 'S') {
                        if (type === 'HEADER') {
                            this.setState({
                                isOrderCancelled: true,
                                selectedRows: [],
                                genericDialogHeading: 'Order Cancelled',
                                genericDialogText: 'The NCRP order has been successfully cancelled.',
                                showGenericOverlayDialog: true
                            });

                            setTimeout(() => {
                                browserHistory.push('/approve-ncrp');
                            }, 1500);
                        }

                        if (type === 'LINE') {
                            this.setState(function (prevState) {
                                return {
                                    cancelledLineIndexes: prevState.cancelledLineIndexes.concat(
                                        prevState.selectedRows
                                    ),
                                    selectedRows: [],
                                    areSelectedLinesCancelled: true
                                };
                            });
                        }
                    } else if (
                        responseObj.message &&
                        responseObj.message.toLowerCase().indexOf('timeout exceeded') !== -1
                    ) {
                        this.setState({
                            messageData: {
                                message: 'Cancellation in progress, please check back after some time.'
                            }
                        });
                    }
                } else {
                    this.setState({
                        messageData: { message: 'Something went wrong.', isError: true }
                    });
                }
            }
        );
    };

    validateOrder(e) {
        e.preventDefault();
        if (!this.isOrderCancellable()) {
            return;
        }
        this.openDialog({
            id: 'headerCancellationDialog',
            onConfirm: this.handleOrderCancellation,
            onCancel: this.closeDialog
        });
    }

    handleLineCancellation = ({ cancellationReason, cancellationComments }) => {
        this.closeDialog();
        const { orderDetails, selectedRows } = this.state;
        const user = this.props.state.user;
        const context = 'NCRP';

        if (!orderDetails || !orderDetails.items || !selectedRows.length) {
            return;
        }

        const linesToCancel = selectedRows.map(index => {
            const lineItem = orderDetails.items[index];
            return {
                CANCELLED_FLAG: 'Y',
                ORDERED_QUANTITY: 0,
                HEADER_ID: orderDetails.headerId || orderDetails.id || orderDetails.orderNumber,
                LINE_ID: lineItem.lineId || lineItem.id || index,
                OPERATION: 'UPDATE',
                CHANGE_REASON: cancellationReason,
                CHANGE_COMMENTS: cancellationComments.trim()
                    ? `${context} - ${user.userDetails.firstName} ${user.userDetails.lastName} - ${cancellationComments.trim()}`
                    : ''
            };
        });

        const payload = {
            P_OPERATION: 'UPDATE',
            P_LINE_TBL: {
                P_LINE_TBL_ITEM: linesToCancel
            },
            P_HEADER_REC: {
                ORDER_NUMBER: orderDetails.orderNumber,
                ORIG_SYS_DOCUMENT_REF:orderDetails.referenceNumber,
            }
        };

        this.processCancellation(payload, 'LINE');
    };

    validateLines(e) {
        e.preventDefault();
        const { selectedRows } = this.state;

        if (!selectedRows.length) {
            return;
        }

        this.openDialog({
            id: 'lineCancellationDialog',
            onConfirm: this.handleLineCancellation,
            onCancel: this.closeDialog
        });
    }
    isLineCancellable = (status) => {
        if (!status) return false;

        const s = status.toUpperCase();

        return (
            s === 'ENTERED' ||
            [
                'AWAITING SHIPPING',
                'AWAITING_SHIPMENT',
                'BACKORDERED',
                'INTERNAL REQ REQUESTED',
                'INTERNAL REQ OPEN',
                'INTERNAL REQ PARTIAL'
            ].includes(s)
        );
    };

    buildApproveOrderPayload = () => {
        const { orderDetails, selectedRows } = this.state;

        const selectedLineItems = selectedRows.map(index => {
            const item = orderDetails.items[index];
            return {
                OPERATION: 'UPDATE',
                BOOKED_FLAG: 'Y',
                HEADER_ID: orderDetails.headerId || orderDetails.id,
                LINE_ID: item.lineId || item.id
            };
        });
        return {
            P_OPERATION: 'UPDATE',
            P_OPERATING_UNIT: 'GE US Appliances',
            RESPONSIBILITY: 'GEOM_SETUP _US_APL',
            RESP_APPLICATION: 'GEONT',
            SECURITY_GROUP: 'STANDARD',
            NLS_LANGUAGE: 'AMERICAN',

            P_HEADER_REC: {
                OPERATION: 'UPDATE',
                BOOKED_FLAG: 'Y',
                HEADER_ID: orderDetails.headerId || orderDetails.id,
                ORDER_NUMBER: orderDetails.orderNumber,
                ORIG_SYS_DOCUMENT_REF:orderDetails.referenceNumber,
                ATTRIBUTE9:"YES",
                ORG_ID: 82
            },

            P_HEADER_VAL_REC: {
                CUSTOMER_NUMBER: orderDetails.accountNumber,
                ORDER_SOURCE: 'NCRP'
            },

            P_LINE_TBL: {
                P_LINE_TBL_ITEM: selectedLineItems
            },
            P_ACTION_REQUEST_TBL: {
                P_ACTION_REQUEST_TBL_ITEM: [
                    {
                        ENTITY_ID: orderDetails.headerId || orderDetails.id,
                        ENTITY_CODE: "HEADER",
                        REQUEST_TYPE: "BOOK_ORDER"
                    }
                ]
            }
        };
    };


    render() {
        const self = this;
        let { orderDetails, pickingUpByAddress, typeOfOrder } = this.state;
        const { dialog } = this.state;
        const totalQuantity = orderDetails && orderDetails.items ? orderDetails.items.reduce((sum, item) => { return sum + Number(item.quantity || 0); }, 0): 0;
        const selectableIndexes = orderDetails
    ? orderDetails.items
        .map((item, index) => {
            if (this.isLineCancellable(item.lineStatus) && !this.state.cancelledLineIndexes.includes(index)) {
                return index;
            }
            return null;
        }).filter(function (i) { return i !== null; }) : [];

    const isApproveEnabled = selectableIndexes.length > 0 && this.state.selectedRows.length === selectableIndexes.length && !this.state.isOrderCancelled;
    let packingNote = null;
    if (orderDetails && orderDetails.packingNotes) {
    packingNote = orderDetails.packingNotes
    }

    let originalUnit = '';
    let invoiceDate = '';

    if (typeof packingNote === 'string' && packingNote.length > 0) {
        const originalUnitMatch = packingNote.match(/Original Unit:\s*([^,]+)/);
        const invoiceDateMatch = packingNote.match(/Invoice Date:\s*([^\n]+)/);
        if (originalUnitMatch) {
            originalUnit = originalUnitMatch[1].trim();
        }
        if (invoiceDateMatch) {
            invoiceDate = invoiceDateMatch[1].trim();
        }
     }

        return (
            <div>
                <style>{mobileStyles}</style>
                <div className="push d-none d-sm-block">
                    <h1 className="pageTitle">APPROVE NCRP REQUEST</h1>
                </div>
                <div className="push d-block d-sm-none m-3">
                    <h1 className="pageTitle">APPROVE NCRP REQUEST</h1>
                </div>
                <div className='d-none d-sm-block'>
                    <h2>CSO (ORDER NUMBER):{orderDetails && orderDetails.orderNumber}</h2>
                    <p><b>ORDER REFERENCE #: {orderDetails && orderDetails.referenceNumber}</b></p>
                    <p><b>Account #: {orderDetails && orderDetails.accountNumber}</b></p>
                </div>
                <div className='d-block d-sm-none m-3'>
                    <h2>CSO (ORDER NUMBER):{orderDetails && orderDetails.orderNumber}</h2>
                    <p><b>ORDER REFERENCE #: {orderDetails && orderDetails.referenceNumber}</b></p>
                    <p><b>Account #: {orderDetails && orderDetails.accountNumber}</b></p>
                </div>
                <p className="bold red">{this.state.errorMessage}</p>
                {orderDetails && <div className='d-none d-sm-block'>
                    <div className="orderReviewColumns columns threeColumns">
                        <div className="orderReviewColumn column column1">
                             <p>
                                <span><strong>Status:</strong> {orderDetails.orderStatus}<br /></span>
                                <span><strong>Order Date:</strong> {moment(orderDetails.orderDate).format("YYYY-MM-DD")}<br /></span>
                                <span><strong>Order started by:</strong> {orderDetails.createdBy}<br /></span>
                            </p>
                            <p>
                                <span><strong>Requested Ship Date:</strong> {moment(orderDetails.requestedDeliveryDate).format("YYYY-MM-DD")}</span><br/>
                                <span><strong>Original Unit: </strong>{originalUnit}</span><br/>
                                <span><strong>Invoice Date: </strong>{invoiceDate}</span>
                            </p>
                        </div>
                        <div className="orderReviewColumn column column2">
                            <p>
                                <span><strong>Customer P.O.:</strong> {orderDetails.poNumber}<br /></span>
                                <span><strong>Order Reference:</strong> {orderDetails.referenceNumber}<br /></span>
                                <span><strong>Shipping Method:</strong> {orderDetails.deliveryMethod}<br /></span>
                                <span><strong>Order Type:</strong> {orderDetails.orderType}<br /></span>
                            </p>
                             <p>
                                <span><strong>Delivery Phone:</strong> {orderDetails.deliveryPhone}</span>
                            </p>
                             
                        </div>
                        {typeOfOrder === 'return'
                            ?<div className="orderReviewColumn column column3">
                            {orderDetails.shippingAddress[0] && <p>
                                <strong>Ship to</strong>:<br />
                                {orderDetails.shippingAddress[0].addressName && <span>{orderDetails.shippingAddress[0].addressName}<br /></span>}
                                <span>{orderDetails.shippingAddress[0].address1}<br /></span>
                                <span>{orderDetails.shippingAddress[0].city + ', ' + orderDetails.shippingAddress[0].state + ' ' + orderDetails.shippingAddress[0].zip}<br /></span>
                                {orderDetails.shippingAddress[0].phone && <span>{this.props.normalizePhoneNumber(orderDetails.shippingAddress[0].phone)}<br /></span>}
                            </p>} 
                             {orderDetails.billingAddress && <p>
                                <strong>Bill to</strong>:<br />
                                {orderDetails.billingAddress.addressName && <span>{orderDetails.billingAddress.addressName}<br /></span>}
                                <span>{orderDetails.billingAddress.address1}<br /></span>
                                <span>{orderDetails.billingAddress.city + ', ' + orderDetails.billingAddress.state + ' ' + orderDetails.billingAddress.zip}<br /></span>
                                {orderDetails.billingAddress.phone && <span>{this.props.normalizePhoneNumber(orderDetails.billingAddress.phone)}<br /></span>}
                            </p>} 
                            </div>
                            :<div className="orderReviewColumn column column3" />
                        }
                    </div>
                    <div className="push">
                        <table className="dataTable viewReturnsTable">
                           <thead>
                            <tr className="viperDarkHeader">
                                <th style={{ textAlign: 'center' }}>
                                    <input
                                        type="checkbox"
                                         checked={
                                            selectableIndexes.length > 0 &&
                                            this.state.selectedRows.length === selectableIndexes.length
                                        }
                                        onChange={this.handleSelectAll}
                                    />
                                    <span style={{ marginLeft: '6px' }}>All</span>
                                </th>
                                <th className="sales">Sales Agreement</th>
                                <th className="item" style={{ textAlign: 'left' }}>Item</th>
                                <th className="originalItem" style={{ textAlign: 'left' }}>Original Item</th>
                                <th className="itemDescription" style={{ textAlign: 'left' }}>Item Description</th>
                                <th className="orderQty">Order Qty</th>
                            </tr>
                        </thead>

                           <tbody>
                                {orderDetails.items.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center' }}>
                                         <input
                                            type="checkbox"
                                            checked={this.state.selectedRows.includes(index)}
                                            onChange={() => this.handleRowSelect(index)}
                                            disabled={
                                                !this.isLineCancellable(item.lineStatus) ||
                                                this.state.cancelledLineIndexes.includes(index)
                                            }
                                        />
                                        </td>
                                        <td className="sales">{item.agreementName}</td>
                                        <td className="item" >{item.item}</td>
                                        <td className="originalItem">{item.originalItem}</td>
                                        <td className="itemDescription">
                                            {item.itemDescription}
                                        </td>
                                        <td className="orderQty">
                                            {item.quantity}
                                        </td>
                                    </tr>
                                ))}
                                 <tr className="totalRow">
                                    <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                         Total Items
                                    </td>
                                    <td colSpan="4" style={{ textAlign: 'right', fontWeight: 'bold' }}>
                                        {` `}
                                    </td>
                                    <td className="orderQty" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        {totalQuantity}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>}

                {/* ── Mobile-only order details block ── */}
                {orderDetails && <div className='d-block d-sm-none ncrp-mobile-wrap'>
                    <p>
                        <span><strong>Status:</strong> {orderDetails.orderStatus}<br /></span>
                        <span><strong>Order Date:</strong> {moment(orderDetails.orderDate).format("YYYY-MM-DD")}<br /></span>
                        <span><strong>Order started by:</strong> {orderDetails.createdBy}<br /></span>
                    </p>
                    <p>
                        <span><strong>Requested Ship Date:</strong> {moment(orderDetails.requestedDeliveryDate).format("YYYY-MM-DD")}<br /></span>
                        <span><strong>Original Unit:</strong> {originalUnit || 'NA'}<br /></span>
                        <span><strong>Invoice Date:</strong> {invoiceDate}<br /></span>
                    </p>
                    {typeOfOrder === 'return' && orderDetails.shippingAddress[0] && <p>
                        <strong>Ship to</strong>:<br />
                        {orderDetails.shippingAddress[0].addressName && <span>{orderDetails.shippingAddress[0].addressName}<br /></span>}
                        <span>{orderDetails.shippingAddress[0].address1}<br /></span>
                        <span>{orderDetails.shippingAddress[0].city + ', ' + orderDetails.shippingAddress[0].state + ' ' + orderDetails.shippingAddress[0].zip}<br /></span>
                    </p>}
                    <p>
                        <span><strong>Customer P.O.:</strong> {orderDetails.poNumber}<br /></span>
                        <span><strong>Delivery Phone:</strong> {orderDetails.deliveryPhone}<br /></span>
                    </p>
                    <table className="ncrp-mobile-table">
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={selectableIndexes.length > 0 && this.state.selectedRows.length === selectableIndexes.length}
                                        onChange={this.handleSelectAll}
                                    />
                                    <span style={{ marginLeft: '4px' }}>All</span>
                                </th>
                                <th>Item</th>
                                <th>Item Description</th>
                                <th className="col-qty">Order Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderDetails.items.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={this.state.selectedRows.includes(index)}
                                            onChange={() => this.handleRowSelect(index)}
                                            disabled={
                                                !this.isLineCancellable(item.lineStatus) ||
                                                this.state.cancelledLineIndexes.includes(index)
                                            }
                                        />
                                    </td>
                                    <td>{item.item}</td>
                                    <td>{item.itemDescription}</td>
                                    <td className="col-qty">{item.quantity}</td>
                                </tr>
                            ))}
                            <tr className="totalRow">
                                <td colSpan="3"><strong>Total Items</strong></td>
                                <td className="col-qty"><strong>{totalQuantity}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="ncrp-mobile-actions">
                        <button className={`blueButton ${!isApproveEnabled ? 'disabled' : ''}`}  onClick={isApproveEnabled ? this.handleApproveReturn.bind(this) : e => e.preventDefault()} disabled={!isApproveEnabled}>
                            APPROVE ORDER
                        </button>
                        <button onClick={this.validateOrder} disabled={this.state.isOrderCancelled}>CANCEL ORDER</button>
                        <button onClick={this.validateLines} disabled={!this.state.selectedRows.length}>CANCEL SELECTED LINES</button>
                        <a href="" onClick={this.handleReturnToPreviousPage.bind(this)}>Return to Previous Screen</a>
                    </div>
                </div>}

                <div className="actionBar d-none d-sm-block">
                    <div className="approveDetailsHeader">
                        <div className="textLeft" style={{ margin: 0 }}>
                            <a href="" onClick={this.handleReturnToPreviousPage.bind(this)} style={{ marginRight: '16rem' }}>
                            Return to Previous Screen
                            </a>
                        </div>

                        <div style={{ margin: '0rem'}}>
                            <div className="approveDetailsHeaderItems">
                            <button onClick={this.validateLines} 
                            disabled={!this.state.selectedRows.length }
                            style={{ marginRight: '1rem' }}>CANCEL SELECTED LINES</button>
                            <button onClick={this.validateOrder}  disabled={this.state.isOrderCancelled} style={{ marginRight: '1rem' }}>CANCEL ORDER</button>
                           <button className={`blueButton ${!isApproveEnabled ? 'disabled' : ''}`} onClick={isApproveEnabled ? this.handleApproveReturn.bind(this) : e => e.preventDefault()} disabled={!isApproveEnabled}>
                                Approve Order
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
                {dialog && ['lineCancellationDialog', 'headerCancellationDialog'].includes(dialog.id) && (
                    <PartsNetOrderCancellationDialog
                        type={dialog.id === 'lineCancellationDialog' ? 'LINE' : 'HEADER'}
                        onConfirm={dialog.onConfirm}
                        onCancel={dialog.onCancel}
                    />
                )}

                {dialog && dialog.id === 'lineStatusDescriptionDialog' && (
                    <LineStatusDescriptionsOverlayDialog
                        handleDialog={this.closeDialog}
                        showDialog={true}
                        context={this.context}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        state,
        user: state.user
    };
};


const mapDispatchToProps = (dispatch) => ({
    dispatch,

    validateWarehouseCode: (payload, callback) =>
        dispatch(validateWarehouseCode(payload, callback)),
    
    processOrder: (payload, query, showLoader, callback) =>
        dispatch(processOrder(payload, query, showLoader, callback)),
});
ApproveNcrpOrderDetails = connect(mapStateToProps, mapDispatchToProps)(ApproveNcrpOrderDetails);
export default ApproveNcrpOrderDetails;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/approveNcrpOrderDetails.js